module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "avator"
  }, [_c('div', {
    staticClass: "icon",
    attrs: {
      "id": "container"
    }
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.icon,
      "id": "pickfiles"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-link', {
    attrs: {
      "to": "/record/setting"
    }
  }, [_c('div', {
    staticClass: "setting"
  })]), _vm._v(" "), _c('div', {
    staticClass: "heart"
  }), _vm._v(" "), _c('div', {
    staticClass: "name",
    domProps: {
      "textContent": _vm._s(_vm.name)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "other",
    domProps: {
      "textContent": _vm._s(_vm.other)
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f3c471e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/peopleHeader.vue
// module id = 772
// module chunks = 1